import React from 'react'

const ReferentButton = ({ referent }) => {
    return (
        <div className="speaker-cv-container">

            <div className="gruppe-referent">
                <img className="referent-foto" src={`${process.env.PUBLIC_URL}/assets/images/${referent.Foto}`} />
                <div className="valign-text-middle">
                    <div>{referent.Titel}</div>
                    <div className="link-underline">{referent.Vorname} {referent.Nachname}</div>
                </div>
            </div>
        </div>
    )
}

export default ReferentButton


